export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.28-1326.29",
  commitId: "532007ac77c159c37d84189e6d331571501f4e7b",
  commitTime: "2026-05-28T13:26:29.000Z",
});
